/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useCallback, useMemo } from "react";
import {useLocation} from "react-router";
import {NavLink}  from "react-router-dom";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl, toAbsoluteRouterUrl} from "../../../../_helpers";
import { useFeatureAccessContext } from "../../../../../app/contexts/FeaturesAccess";

import * as icons from "@material-ui/icons";
import { abmActions } from "../../../../../redux/actions/abm.actions";
import { connect, createDispatchHook, useDispatch } from "react-redux";
import { useAction } from "../../../../../app/hooks";

const getIcon = name => {
  return icons[name];
}


export const getCurrentUrl = (location) => {
  /*console.log("getCurrentUrl", location.pathname)
  console.log("getCurrentUrl", location.pathname.split("/Abm/")[1] && location.pathname.split("/Abm/")[1].split("/")[0]);*/
  return location.pathname.split("/Abm/")[1] && location.pathname.split("/Abm/")[1].split("/")[0];
}

function checkIsActive(location, url) {
  const current = getCurrentUrl(location);
  if (!current || !url) {
    return false;
  }
  const result = (current.toLowerCase() === url.toLowerCase()
    || current.toLowerCase().startsWith(`${url.toLowerCase()}/`)
    || current.toLowerCase().endsWith(`/${url.toLowerCase()}`)
    || current.toLowerCase().indexOf(`/${url.toLowerCase()}/`) > -1);

  //console.log("checkIsActive", {current, url, result});

  return result;
}


const _AsideMenuCustomList = ({ layoutProps, noSavedChanges, ...props }) => {

  const {menu} = useFeatureAccessContext(); 
  const location = useLocation();
  const controller = getCurrentUrl(location);

  const dispatch = useDispatch();
  
  const saveChangeValues = () => {  
    const editItem = (item) => dispatch(abmActions(controller).editItem(item.id, item));
    const updateLocalItem = (item) => dispatch(abmActions(controller).updateLocalItem(item));
    if(!props[controller]) return;
    const item = props[controller].noSavedChanges.values;
    const state = props[controller].noSavedChanges.state;
    const canEdit = props.config.controllers.find(c => c.name === controller)?.policy?.edit;
    if(state && item && item.id && item.id !== 0 && canEdit){
      editItem(item).then(response => updateLocalItem(response));
    } 
  }
  const devMenu = React.useMemo(() => {
    console.log("cambio menu");
    return menu;
  }, [menu]);

  const getMenuItemActive = useCallback((url, hasSubmenu = false) => {
    return checkIsActive(location, url)
        ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
        : "";
  }, [location]);

  const handleFeatureClick = ( name ) => {
    saveChangeValues();
  }

  return (
      <>
        <SystemMenu menu={menu} menuItemActive={getMenuItemActive} layoutProps={layoutProps} onFeatureClick={handleFeatureClick} />        
      </>
  );
}

const SystemMenu = ({menu, layoutProps, menuItemActive, onFeatureClick}) =>{
  
  return (
    <ul className={`menu-nav ${layoutProps.ulClasses}`}>
      <>
        {menu.sectionRoot && <SystemSection {...menu.sectionRoot}  menuItemActive={menuItemActive} onFeatureClick={onFeatureClick}/>}
        {menu.sections && menu.sections.map((section, section_index) => (
          <SystemSection key={section_index} {...section}  menuItemActive={menuItemActive} onFeatureClick={onFeatureClick}/>
        ))}
      </>
    </ul>

  )

}

const SystemSection = ({caption, features, menuItemActive, onFeatureClick}) => {
  return (
    <>
      {caption && 
        <li className="menu-section">
          <h4 className="menu-text">{caption}</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
      }
      {features && features.map((feature,feature_index)=> (
        feature.features ? 
          <FeatureGroup key={feature_index} {...feature} menuItemActive={menuItemActive} onFeatureClick={onFeatureClick}/> :
          <Feature key={feature_index} {...feature} menuItemActive={menuItemActive} onClick={onFeatureClick}/>
      ))}
    </>
  )
}


export const FeatureGroup  = ({caption, features, url, icon, menuItemActive, onFeatureClick}) => {
  const Icon = getIcon(icon);
  return(
    <>
      <li
          className={`menu-item menu-item-submenu ${menuItemActive(url, true)}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
      >
        <a className="menu-link menu-toggle">
          <span className="svg-icon menu-icon">
            {Icon 
            ? <Icon /> 
            : (icon ?
              (<SVG src={toAbsoluteUrl(icon)}/>) :
              <SVG src={toAbsoluteUrl("media/svg/icons/Custom/Scrubber.svg")}/>
            )}
          </span>
          <span className="menu-text">{caption}</span>
          <i className="menu-arrow"/>
        </a>
        <div className="menu-submenu ">
          <i className="menu-arrow"/>
          <ul className="menu-subnav">
          {features && features.map((feature, feature_index)=> (
            feature.features ? 
              <FeatureGroup key={feature_index} {...feature}  menuItemActive={menuItemActive} onFeatureClick={onFeatureClick}/> :
              <Feature key={feature_index} {...feature} menuItemActive={menuItemActive} onClick={onFeatureClick} />
          ))}
          </ul>
        </div>
      </li>
    </>
  )
}


const Feature = ({caption, url, icon, menuItemActive, onClick, name, type, action, message }) => {

  const Icon = getIcon(icon);
  const actionHook = useAction({ caption, action, message })

  const handleClick = (event) => {
    if(type === "dialog"){
      event.preventDefault();
      actionHook.exec();
    }else{
      onClick(name);
    }
  }

  return(
    <li
      className={`menu-item ${menuItemActive(name, false)}`}
      aria-haspopup="true"
    >

        <NavLink className="menu-link" isActive={(x, location)=>{
          return checkIsActive(location, name)
        }} to={toAbsoluteRouterUrl(url ? url : "/")} onClick={handleClick}>
          <span className="svg-icon menu-icon">
          {Icon 
          ? <Icon /> 
          : (icon ?
            (<SVG src={toAbsoluteUrl(icon)}/>) :
            <SVG src={toAbsoluteUrl("media/svg/icons/Custom/Scrubber.svg")}/>
          )}
          </span>
          <span className="menu-text">{caption}</span>
        </NavLink>

    </li>
  )
}


const mapStateToProps = (state) => state;


export const AsideMenuCustomList = connect(mapStateToProps)(_AsideMenuCustomList);

